/**
 * Block B / B4 — Wasser- und Atemschutz-Konstanten (Wiki).
 * Datenstruktur + Anzeige in Block B; Verbrauchslogik kommt mit Phase 5.
 */

/** Standardwasserabgabe pro Strahlrohr/Pumpe (L/min). */
export const WATER_OUTPUT_STANDARD = 200;

/** Förderleistung an Hydranten (L/min). */
export const WATER_OUTPUT_HYDRANT = 400;

/** Förderleistung über DLK-Wasserwerfer (L/min). */
export const WATER_OUTPUT_DLK = 400;

/** Bonus durch Werfer-Modul (L/min). */
export const WATER_OUTPUT_MONITOR_BONUS = 200;

/** Maximale B-Schlauch-Strecke vom Hydranten zum Einsatzort (m). */
export const WATER_MAX_HOSE_DISTANCE_M = 16_000;

/** Atemluftverbrauch pro AGT (L/min). */
export const BREATHING_AIR_CONSUMPTION = 200;

/** Schwellwert (Anteil), unterhalb dessen ein AGT als kritisch gilt. */
export const BREATHING_AIR_CRITICAL_THRESHOLD = 0.25;

/** Atemluft-Reserve eines voll bestückten GW (Liter). */
export const BREATHING_AIR_SUPPLY_UNIT = 80_000;

/** Verschleiß je abgeschlossenem Einsatz (0–1). */
export const VEHICLE_WEAR_PER_MISSION = 0.01;

/** Kondition unterhalb dieses Werts → Werkstatt-Pflicht. */
export const VEHICLE_REPAIR_THRESHOLD = 0.25;

/** Werkstatt-Kosten = baseRepair × Multiplier. */
export const VEHICLE_REPAIR_COST_MULTIPLIER = 1.4;
